import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Button } from '../Button';
import { CircleIcon } from '../Icons/CircleIcon';
import { SquareIcon } from '../Icons/SquareIcon';
import { TriangleIcon } from '../Icons/TriangleIcon';

export const StyledChipButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'chipColor',
})<{ isActive?: boolean; chipColor?: string }>`
  max-height: 40px;
  border-radius: 100px;
  padding: 0;
  max-width: 384px;
  width: fit-content;
  display: flex;
  gap: ${({ theme }) => theme.spacing(Spacing.Small)};
  align-items: center;
  color: ${({ theme, isActive }) =>
    isActive ? theme.palette.background.paper : theme.palette.text.primary};
  border-color: ${({ theme, isActive, chipColor }) =>
    isActive ? chipColor : theme.palette.neutral[200]};
  background-color: ${({ theme, isActive, chipColor }) =>
    isActive ? chipColor : theme.palette.background.paper};
`;

export const StyledCircle = styled(CircleIcon, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.background.paper : theme.palette.neutral[300]};
`;

export const StyledSquare = styled(SquareIcon, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.background.paper : theme.palette.green[600]};
`;

export const StyledTriangle = styled(TriangleIcon, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.background.paper : theme.palette.red[600]};
`;
